import angular from 'angular';
import ngshowdown from 'ng-showdown';
import ngsanitize from 'angular-sanitize';

import zebraService from '../../services/zebra.service.js';

export default angular.module('components.record', [
    zebraService,
    'ngSanitize',
    'ng-showdown'
])
    .config(['$showdownProvider', function($showdownProvider) {
        $showdownProvider.setOption('openLinksInNewWindow', true)
    }])
    .component('displayRecord', {
        bindings: {
            content: '<',
            schema: '@',
            mode: '@'
        },
        template: require('./displayRecord.pug')()
    })
    .component('getRecordById', {
        bindings: {
            catalogid: '@',
            docid: '<',
            schema: '@',
            mode: '@'
        },
        template: '<display-record mode="{{$ctrl.mode}}" schema="{{$ctrl.schema}}" content="$ctrl.response.records[0].recordData"></display-record>',
        controller: [ 'ZebraService', function(ZebraService) {
            var ctrl = this;

            ctrl.load = function() {
                var self = this;
                var params = {};

                ctrl.response = null;
                ctrl.error = null;

                params.id = ctrl.catalogid;
                params.operation = 'search';
                params.query = 'rec.id="' + ctrl.docid.replace(/\\/g, '\\\\')+ '"';
                params.recordSchema = ctrl.schema;
                ZebraService.get(params).$promise.then(function(response) {
                    self.response = response;
                }, function(err) {
                    self.error = err.message || err;
                    console.log(self.error);
                });
            };

            ctrl.$onChanges = function(changes) {
                if (changes) {
                    ctrl.load();
                }
            };
        }]

    })
    .component('getOpacById', {
        bindings: {
            docid: '<'
        },
        template: '<display-record schema="opac" content="$ctrl.response.data.records[0].recordData"></display-record>',
        controller: [ 'ItemService', function(ItemService) {
            var ctrl = this;

            ctrl.load = function() {
                var self = this;
                var params = {};

                ctrl.record = null;
                ctrl.error = null;

                params.cat = 'document';
                params.syntax = 'opac';
                params.docid = ctrl.docid.replace(/\\/g, '\\\\');
                ItemService.get(params).$promise.then(function(response) {
                    self.response = response;
                }, function(err) {
                    self.error = err.message || err;
                    console.log(self.error);
                });
            };
            ctrl.$onChanges = function(changes) {
                if (changes) {
                    ctrl.load();
                }
            };
        }]


    })
 
/*
    .name;

import ngfilter from 'angular-filter';
import ngsanitize from 'angular-sanitize';
import ngshowdown from 'ng-showdown';

import itemService from '../../services/item.service.js';

import recordDisplayController from './recordDisplay.controller.js';
import recordGetController from './recordGet.controller.js';
import recordGetOpacController from './recordGetOpac.controller.js';

export default angular.module('components.record', [
    'angular.filter',
    zebraService,
    itemService,
    ngsanitize,
    'ng-showdown'
])
    .component('recordDisplay', {
        template: require('./recordDisplay.pug')(),
        bindings: {
            mode: '@',
            schema: '@',
            record: '<'
        },
        controller: recordDisplayController
    })
    .component('recordGet', {
        template: require('./recordGet.pug')(),
        bindings: {
            catalogid: '@',
            mode: '@',
            schema: '@',
            docid: '<'
        },
        controller: recordGetController
    })
    .component('recordGetOpac', {
        template: require('./recordGetOpac.pug')(),
        bindings: {
            mode: '@',
            schema: '@',
            docid: '<'
        },
        controller: recordGetOpacController
    })
    */
    .filter('bib', function() {
        return function(input) {
            return _bib(input);
        };
        ////////
        function _bib(input) {
            var out = '';
            if (typeof input === 'object') {
                if (Array.isArray(input) && input.length>1) {
                    var i;
                    for (i in input) {
                        if (i!=0) {
                            out += "; ";
                        }
                        out += _bib(input[i]);
                    }
                } else {
                    var prop;
                    for (prop in input) {
                        out += _bib(input[prop]);
                    }
                }
            } else if (typeof input === 'string') {
                out += input;
            } 
            return out;
        }
    })
    .filter('bibdomain', function() {
        var bibdomains = { 
            "header":  __('Author'),
            "domain1": __('Title/statement of responsibility'),
            "domain2": __('Edition area'),
            "domain3": __('Material or type of resource specific area'),
            "domain4": __('Publication, production, distribution etc., area'),
            "domain5": __('Material description'),
            "domain6": __('Series and multipart monographic resource area'),
            "domain7": __('Note area'),
            "domain8": __('Resource identifier'),
            "other-authors": __('Other authors'),
            "subjects": __('Keywords, subject headings'),
            "referat": __('Abstract'),
            "url": __('URL'),
            "classification":  __('Classifications'),
            "source": __('Record source'),
            "misc": __('Misc'),
            "domain-authorities-header": __('Access points'),
            "domain-authorities-notes": __('Note'),
            "domain-authorities-sources": __('Note'),
            "toc": __('Table of contents'),
            "include": __('Bound with')
        };
        return function(name) {
            return bibdomains[name] || name;
        }
    })
    .filter('urltype', function() {
        var urltypes = {
            "content": __("content"),
            "thumbnail": __("thumbnail"),
            "cover": __("cover")
        };
        return function(name) {
            return urltypes[name] || name;
        }
    })
    .filter('getLocationName', function() {
        var locations = [
            {name:"Все фонды", value:""},
            {name:"научно-методический отдел", value:"НМО"},
            {name:"научный фонд", value:"НФ"},
            {name:"редкий фонд", value:"РФ"},
            {name:"учебный фонд", value:"УФ"},
            {name:"художественный фонд", value:"ХФ"},
            {name:"читальный зал гуманитарной литературы", value:"ЧЗГЛ"},
            //
            //{name:"читальный зал справочно-библиографических изданий", value:"ЧЗСБИ"},
            //
            {name:"читальный зал иностранной литературы", value:"ЧЗИЛ"},
            {name:"читальный зал периодических изданий", value:"ЧЗПИ"},
            {name:"читальный зал курсового и дипломного проектирования", value:"ЧЗКДП"},
            {name:"читальный зал технической литературы", value:"ЧЗТЛ"},
            {name:"читальный зал электронных ресурсов", value:"ЧЗЭР"},
            {name:"кафедра методики преподавания иностранных языков", value:"ЯЦ_МПИЯ"},
            {name:"кафедра иностранного языка ИСГТ", value:"ЯЦ_ИСГТ"},
            {name:"кафедра иностранного языка ИПР", value:"ЯЦ_ИПР"},
            {name:"кафедра иностранного языка ИФВТ", value:"ЯЦ_ИФВТ"},
            {name:"кафедра иностранного языка ИНК", value:"ЯЦ_ИНК"},
            {name:"кафедра иностранного языка ЭНИН", value:"ЯЦ_ЭНИН"},
            {name:"кафедра иностранного языка ФТИ", value:"ЯЦ_ФТИ"},
            {name:"подготовительное отделение ИМОЯК", value:"ЯЦ_ИМОЯК_ПО"},
            {name:"языковой центр ИМОЯК, к. 312 корпус 19", value:"ЯЦ_ИМОЯК1"},
            {name:"языковой центр ИМОЯК, к. 423 корпус 19", value:"ЯЦ_ИМОЯК2"},
            {name:"языковой центр ИМОЯК, к. 518 корпус 19", value:"ЯЦ_ИМОЯК3"},
            {name:"языковой центр \"Медиатека\" ИСГТ", value:"ЯЦ_Медиатека"},
            {name:"языковой центр \"Медиатека\" ШБИП", value:"ЯЦ_ШБИП"},
            {name:"кафедра иностранного языка ИК, корпус 10", value:"ЯЦ_ИК1"},
            {name:"кафедра иностранного языка ИК", value:"ЯЦ_ИК"},
            {name:"ресурсный центр языковой подготовки", value:"ЯЦ_РЦЯП"}
        ];
        function _get_name_by_val(value) {
            for (var i in locations) {
                if (locations[i].value === value) {
                    return locations[i].name;
                }
            }
            return null;
        }
        return function(input) {
            return _get_name_by_val(input);
        };
    })
    .filter('circ_summary', function() {
        return function(input) {
            return input;
        };
    })
    .filter('circ_summary', function() {
        return function(input, param) {
            var sum_all = 0;
            var sum_available_now = 0;
            for (var i in input) {
                var cs = input[i].circulations[0].circulation;
                for(var j in cs) {
                    sum_all++;
                    if (cs[j].availableNow[0].ATTR.value[0] === "1") {
                        sum_available_now++;
                    }
                }
            }
            if (param === 'available_now') {
                return sum_available_now;
            } else if (param === 'all') {
                return sum_all;
            }
        };
    })
    .name;
